import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResultsService {
  private http = inject(HttpClient);

  convertTrackAndVehicleData(
    tracks: unknown[],
    simulationResults: Record<string, unknown>
  ): Observable<any> {
    const url = environment.apiURL + '/results/export-data';
    const payload = {
      tracks,
      simulationResults
    };
    return this.http.post(url, payload);
  }
}
